module.exports = {
    appkey: "a7d5168792f036ef594d8384e2e190bed8e6ab5dfd19be7ec92be617f2b99b57",
    authtoken: "k4fROzo40r50atHuQAR2bifExiDraqabR3CaphiXEdEHespl4hexl2Rlw6aS3ete",
    authtoken_app: "mawRiTrLGU6achehusL2t3CuYu8WEJuglPrOBr*thoP*&j?SldR-xuphOzokumow",
};